import React from "react";
import { Link, LinkProps, useLocation } from "react-router-dom";
import classes from "./LinkButton.module.css";

interface Props extends LinkProps {
    className?: string;
}

const LinkButton = (props: Props) => {
    const router = useLocation();
    return (
        <Link
            {...props}
            className={`${classes.linkButton} ${
                router.pathname.endsWith(String(props.to)) ? classes.linkButtonActive : ""
            } ${props.className || ""}`}
        />
    );
};

export default LinkButton;
